export function renderHabitModal(onSave, onCancel, onDelete, habitToEdit = null) {
  const modalRoot = document.getElementById('modal-root') || createModalRoot();
  const isEdit = !!habitToEdit;

  modalRoot.innerHTML = `
    <div class="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-df-sapphire/20 backdrop-blur-md animate-in fade-in duration-300 overflow-y-auto">
      <div class="bg-white w-full max-w-sm rounded-[2.5rem] shadow-2xl p-8 my-auto transform animate-in zoom-in-95 slide-in-from-bottom-10 duration-500 ease-out border border-white/50 max-h-none sm:max-h-[90vh] overflow-y-visible sm:overflow-y-auto mb-20">
        <div class="flex items-center justify-between mb-8">
            <div class="flex items-center space-x-3">
              <div class="w-2 h-8 bg-df-sapphire rounded-full"></div>
              <h2 class="text-3xl font-black text-df-sapphire tracking-tight">${isEdit ? 'Edit Habit' : 'Add Habit'}</h2>
            </div>
            ${isEdit ? `
              <button id="modal-delete" class="p-3 text-red-500 hover:bg-red-50 rounded-2xl transition-colors" title="Delete Habit">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
              </button>
            ` : ''}
        </div>
        
        <div class="space-y-7">
          <div>
            <label class="block text-[10px] font-black text-df-bluegrey uppercase tracking-[0.2em] mb-3 ml-1 opacity-60">Title</label>
            <input type="text" id="habit-title" placeholder="e.g. Morning Yoga" value="${habitToEdit?.title || ''}"
              class="w-full px-5 py-4 bg-gray-50 border-2 border-transparent focus:border-df-sapphire/10 rounded-2xl focus:ring-4 focus:ring-df-sapphire/5 outline-none transition-all placeholder:text-gray-300 font-bold text-df-sapphire">
          </div>

          <div class="bg-gray-50 p-5 rounded-[2rem] border border-gray-100/50">
            <div class="flex justify-between items-center mb-1">
                <span class="text-[10px] font-black text-df-bluegrey uppercase tracking-[0.2em] opacity-60 ml-1">Track Type</span>
            </div>
            <div class="flex bg-white p-1.5 rounded-2xl shadow-sm border border-gray-100 mt-2">
              <button id="type-binary" class="flex-1 py-3 rounded-xl text-xs font-black transition-all">Binary</button>
              <button id="type-numeric" class="flex-1 py-3 rounded-xl text-xs font-black transition-all text-df-bluegrey hover:bg-gray-50">Numeric</button>
            </div>
          </div>

          <div id="numeric-fields" class="hidden animate-in slide-in-from-top-4 duration-300 space-y-6">
            <div class="bg-gray-50 p-5 rounded-[2rem] border border-gray-100/50">
              <span class="text-[10px] font-black text-df-bluegrey uppercase tracking-[0.2em] opacity-60 ml-1">Goal Direction</span>
              <div class="flex bg-white p-1.5 rounded-2xl shadow-sm border border-gray-100 mt-2">
                <button id="dir-increase" class="flex-1 py-3 rounded-xl text-xs font-black transition-all">Increase</button>
                <button id="dir-decrease" class="flex-1 py-3 rounded-xl text-xs font-black transition-all text-df-bluegrey hover:bg-gray-50">Decrease</button>
              </div>
            </div>
            <div class="bg-gray-50 p-5 rounded-[2rem] border border-gray-100/50">
              <div class="flex justify-between items-center mb-3">
                <span class="text-[10px] font-black text-df-bluegrey uppercase tracking-[0.2em] opacity-60 ml-1">Auto-sync (Health)</span>
                <label class="relative inline-flex items-center cursor-pointer">
                  <input type="checkbox" id="habit-autosync" class="sr-only peer" ${habitToEdit?.integration_id ? 'checked' : ''}>
                  <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-df-aqua"></div>
                </label>
              </div>
              <div id="autosync-options" class="${habitToEdit?.integration_id ? '' : 'hidden'} mt-4">
                 <select id="habit-integration-id" class="w-full px-4 py-3 bg-white border border-gray-100 rounded-xl font-bold text-df-sapphire text-xs focus:ring-2 focus:ring-df-aqua/20 outline-none">
                    <option value="steps" ${habitToEdit?.integration_id === 'steps' ? 'selected' : ''}>Steps (Apple/Google Health)</option>
                    <option value="distance" ${habitToEdit?.integration_id === 'distance' ? 'selected' : ''}>Distance (Apple/Google Health)</option>
                 </select>
              </div>
            </div>
            <div class="grid grid-cols-2 gap-4">
              <div>
                <label class="block text-[10px] font-black text-df-bluegrey uppercase tracking-[0.15em] mb-2 ml-1 opacity-60">Goal</label>
                <input type="number" id="habit-goal" value="${habitToEdit?.goal || 1}" 
                  class="w-full px-5 py-4 bg-gray-50 border-none rounded-2xl focus:ring-4 focus:ring-df-sapphire/5 outline-none transition-all font-bold text-df-sapphire">
              </div>
              <div>
                <label class="block text-[10px] font-black text-df-bluegrey uppercase tracking-[0.15em] mb-2 ml-1 opacity-60">Unit</label>
                <input type="text" id="habit-unit" placeholder="cups, km" value="${habitToEdit?.unit || ''}"
                  class="w-full px-5 py-4 bg-gray-50 border-none rounded-2xl focus:ring-4 focus:ring-df-sapphire/5 outline-none transition-all font-bold text-df-sapphire">
              </div>
            </div>
          </div>

          <div class="bg-gray-50 p-5 rounded-[2rem] border border-gray-100/50">
            <label class="block text-[10px] font-black text-df-bluegrey uppercase tracking-[0.2em] mb-3 ml-1 opacity-60">Repeat Days</label>
            <div id="repeat-days" class="flex justify-between px-1">
              ${['S', 'M', 'T', 'W', 'T', 'F', 'S'].map((d, i) => `
                <button data-day="${i}" class="day-btn w-8 h-8 rounded-full text-[10px] font-black border border-gray-200 transition-all bg-white text-df-bluegrey hover:border-df-sapphire/30">${d}</button>
              `).join('')}
            </div>
          </div>

          <div class="grid grid-cols-2 gap-4">
            <div>
              <label class="block text-[10px] font-black text-df-bluegrey uppercase tracking-[0.15em] mb-2 ml-1 opacity-60">Start Date</label>
              <input type="date" id="habit-start" value="${habitToEdit?.start_date || ''}" class="w-full px-4 py-3 bg-gray-50 border-none rounded-xl focus:ring-4 focus:ring-df-sapphire/5 outline-none transition-all font-bold text-df-sapphire text-xs">
            </div>
            <div>
              <label class="block text-[10px] font-black text-df-bluegrey uppercase tracking-[0.15em] mb-2 ml-1 opacity-60">End Date</label>
              <input type="date" id="habit-end" value="${habitToEdit?.end_date || ''}" class="w-full px-4 py-3 bg-gray-50 border-none rounded-xl focus:ring-4 focus:ring-df-sapphire/5 outline-none transition-all font-bold text-df-sapphire text-xs">
            </div>
          </div>

          <div class="flex space-x-4 pt-4">
            <button id="modal-cancel" class="flex-1 py-5 rounded-[1.5rem] text-df-bluegrey font-black text-sm uppercase tracking-widest hover:bg-gray-50 transition-colors">Cancel</button>
            <button id="modal-save" class="flex-1 py-5 bg-df-aqua text-white rounded-[1.5rem] font-black text-sm uppercase tracking-widest shadow-xl shadow-df-aqua/30 hover:opacity-90 hover:scale-[1.02] active:scale-[0.98] transition-all">${isEdit ? 'Save' : 'Create'}</button>
          </div>
        </div>
      </div>
    </div>
  `;

  let selectedType = habitToEdit?.type || 'binary';
  let selectedDirection = habitToEdit?.direction || 'increase';
  let selectedDays = habitToEdit?.repeat_days
    ? new Set(habitToEdit.repeat_days.split(',').map(Number))
    : new Set([0, 1, 2, 3, 4, 5, 6]);

  const typeBinary = document.getElementById('type-binary');
  const typeNumeric = document.getElementById('type-numeric');
  const numericFields = document.getElementById('numeric-fields');
  const dirIncrease = document.getElementById('dir-increase');
  const dirDecrease = document.getElementById('dir-decrease');

  const updateTypeUI = () => {
    if (selectedType === 'binary') {
      typeBinary.className = 'flex-1 py-3 rounded-xl text-xs font-black transition-all bg-df-sapphire text-white shadow-lg shadow-df-sapphire/20';
      typeNumeric.className = 'flex-1 py-3 rounded-xl text-xs font-black transition-all text-df-bluegrey hover:bg-gray-50';
      numericFields.classList.add('hidden');
    } else {
      typeNumeric.className = 'flex-1 py-3 rounded-xl text-xs font-black transition-all bg-df-sapphire text-white shadow-lg shadow-df-sapphire/20';
      typeBinary.className = 'flex-1 py-3 rounded-xl text-xs font-black transition-all text-df-bluegrey hover:bg-gray-50';
      numericFields.classList.remove('hidden');
    }
  };

  const updateDirUI = () => {
    if (selectedDirection === 'increase') {
      dirIncrease.className = 'flex-1 py-3 rounded-xl text-xs font-black transition-all bg-df-sapphire text-white shadow-lg shadow-df-sapphire/20';
      dirDecrease.className = 'flex-1 py-3 rounded-xl text-xs font-black transition-all text-df-bluegrey hover:bg-gray-50';
    } else {
      dirDecrease.className = 'flex-1 py-3 rounded-xl text-xs font-black transition-all bg-df-sapphire text-white shadow-lg shadow-df-sapphire/20';
      dirIncrease.className = 'flex-1 py-3 rounded-xl text-xs font-black transition-all text-df-bluegrey hover:bg-gray-50';
    }
  };

  updateTypeUI();
  updateDirUI();

  typeBinary.onclick = () => { selectedType = 'binary'; updateTypeUI(); };
  typeNumeric.onclick = () => { selectedType = 'numeric'; updateTypeUI(); };
  dirIncrease.onclick = () => { selectedDirection = 'increase'; updateDirUI(); };
  dirDecrease.onclick = () => { selectedDirection = 'decrease'; updateDirUI(); };

  const autoSyncCheck = document.getElementById('habit-autosync');
  const autoSyncOptions = document.getElementById('autosync-options');
  const unitInput = document.getElementById('habit-unit');
  const integrationSelect = document.getElementById('habit-integration-id');

  autoSyncCheck.onchange = () => {
    if (autoSyncCheck.checked) {
      autoSyncOptions.classList.remove('hidden');
      if (!unitInput.value) {
        unitInput.value = integrationSelect.value === 'steps' ? 'steps' : 'km';
      }
    } else {
      autoSyncOptions.classList.add('hidden');
    }
  };

  integrationSelect.onchange = () => {
    if (autoSyncCheck.checked) {
      unitInput.value = integrationSelect.value === 'steps' ? 'steps' : 'km';
    }
  };

  document.querySelectorAll('.day-btn').forEach(btn => {
    const day = parseInt(btn.dataset.day);
    if (selectedDays.has(day)) {
      btn.classList.add('bg-df-sapphire', 'text-white', 'border-df-sapphire');
      btn.classList.remove('bg-white', 'text-df-bluegrey', 'border-gray-200');
    }
    btn.onclick = () => {
      if (selectedDays.has(day)) {
        selectedDays.delete(day);
        btn.classList.remove('bg-df-sapphire', 'text-white', 'border-df-sapphire');
        btn.classList.add('bg-white', 'text-df-bluegrey', 'border-gray-200');
      } else {
        selectedDays.add(day);
        btn.classList.add('bg-df-sapphire', 'text-white', 'border-df-sapphire');
        btn.classList.remove('bg-white', 'text-df-bluegrey', 'border-gray-200');
      }
    };
  });

  document.getElementById('modal-save').onclick = () => {
    const title = document.getElementById('habit-title').value;
    const goal = parseFloat(document.getElementById('habit-goal').value);
    const unit = document.getElementById('habit-unit').value;
    const start = document.getElementById('habit-start').value;
    const end = document.getElementById('habit-end').value;

    if (!title) return alert('Please enter a habit title.');

    onSave({
      title,
      type: selectedType,
      goal: selectedType === 'numeric' ? goal : 1,
      unit: selectedType === 'numeric' ? unit : null,
      direction: selectedType === 'numeric' ? selectedDirection : 'increase',
      repeat_days: Array.from(selectedDays).sort().join(','),
      start_date: start || null,
      end_date: end || null,
      integration_id: document.getElementById('habit-autosync').checked ? document.getElementById('habit-integration-id').value : null,
      source_type: document.getElementById('habit-autosync').checked ? (window.Capacitor?.getPlatform() === 'ios' ? 'apple_health' : 'google_fit') : null
    });
    closeModal();
  };

  if (isEdit) {
    document.getElementById('modal-delete').onclick = () => {
      if (confirm('Are you sure you want to delete this habit?')) {
        onDelete(habitToEdit.id);
        closeModal();
      }
    };
  }

  document.getElementById('modal-cancel').onclick = () => { onCancel(); closeModal(); };
}

function createModalRoot() {
  const root = document.createElement('div');
  root.id = 'modal-root';
  document.body.appendChild(root);
  return root;
}

function closeModal() {
  const modal = document.getElementById('modal-root');
  if (modal) modal.innerHTML = '';
}
